import React from 'react';
import { SitecoreContext, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Helmet from 'react-helmet';
const htmlToReact = require('html-to-react');
const { Parser } = htmlToReact;
import InnerHTML from 'dangerously-set-html-content';

type CodeInjectionProps = {
  sitecoreContext: SitecoreContext & {
    pageEditing: boolean;
    custom: {
      siteConfiguration: {
        headerCode: string;
        footerCode: string;
      };
      targetHostName: string;
    };
  };
};

const CodeInjection = ({ sitecoreContext }: CodeInjectionProps): JSX.Element => {
  // Control should not render if page is in editing mode
  if (!sitecoreContext || sitecoreContext.pageEditing) {
    return <div className="codeInjection"></div>;
  }
  let parser = new Parser();
  let siteHeadInjection = sitecoreContext?.custom?.siteConfiguration?.headerCode;
  let siteFooterInjection = sitecoreContext?.custom?.siteConfiguration?.footerCode;

  return (
    <>
      <Helmet>{siteHeadInjection ? parser.parse(siteHeadInjection) : null}</Helmet>
      <InnerHTML html={siteFooterInjection} />
    </>
  );
};

export default withSitecoreContext()(CodeInjection);
